module.exports = __webpack_public_path__ + "static/1-d79ea66fbe7997bb7572fa0546d016bc.jpg";